import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ModalHandler from 'components/shared/modal/modal-handler'
import QuestionModal from 'components/shared/modals/question'
import userActions from 'actions/users/actions'

// @TODO: FAQ Redirection

const Footer = ({ status, locationSlug, id, cancelSubscription }) => {
  const renderCancelMembership = () =>
    <ModalHandler title={`CANCEL MEMBERSHIP`} className="flex justify-center w-3/4 text-primary-darkred py-3 rounded-lg font-bold text-sm cursor-pointer">
      {({ toggle }) => (<QuestionModal title={`Are you sure you want to cancel your plan?`} titleClassName="text-lg font-thin mx-3 py-5" onClose={toggle} onClickYes={() => cancelSubscription(id)} />)}
    </ModalHandler>

  const renderPurchasePlan = () => <a href={`/passport/${locationSlug}`} className="flex justify-center w-3/4 text-primary-orange py-3 rounded-lg font-bold text-sm">
    PURCHASE PLAN
  </a>

  return (
    <>
      <p className="text-sm font-normal my-5 text-center">
        <b>Have a question?</b> Reach out to a
        <a href="#" className="text-primary-orange mx-1">
          Space Expert
        </a>
        or view our
        <a href="https://flyspaces.com/passport" className="text-primary-orange mx-1">
          FAQ
        </a>
      </p>
      {status === 'active' && renderCancelMembership()}
      {status === 'cancelled' && renderPurchasePlan()}
    </>
  )
}

const mapDispatchToProps = {
  cancelSubscription: userActions.cancelUserPassportSubscription,
}

Footer.propTypes = {
  id: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  locationSlug: PropTypes.string,
  cancelSubscription: PropTypes.func.isRequired,
}

export default connect(null, mapDispatchToProps)(Footer)
